import { render } from "./TestApi.vue?vue&type=template&id=f57cb8a4&scoped=true"
import script from "./TestApi.vue?vue&type=script&lang=js"
export * from "./TestApi.vue?vue&type=script&lang=js"

import "./TestApi.vue?vue&type=style&index=0&id=f57cb8a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57cb8a4"]])

export default __exports__